import { makeAutoObservable } from 'mobx';
import setObjectKetValue from '../../../helpers/setObjectKetValue';
// const initialState = propertyDefault();

class PropertyAddEditState {
  constructor(initialData) {
    this.state = initialData;
    makeAutoObservable(this);
  }

  state = null;

  get maxDepositAmount() {
    const { tenancyRentAmount } = this.state;

    return tenancyRentAmount ? ((tenancyRentAmount * 12) / 52) * 5 : 0;
  }

  get maxDepositAmountStr() {
    return this.maxDepositAmount.toFixed(2);
  }

  setState(key, value) {
    console.log(this.state);
    console.log(key, value);
    setObjectKetValue(this.state, key, value);
    // this.state[key] = value;
  }
}

export default PropertyAddEditState;

// const state = new PropertyAddEditState();
// const usePropertyAddEditState = () => state;
//
// export default state;
// export { usePropertyAddEditState };
